import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import ActionPanel from '../../components/action-panel-modal/action-panel';
import warningIcon from '../../assets/img/Icon - Warning.svg'
import { useHistory, Redirect } from 'react-router-dom';

const CancelModal = ({show, onHide, redirectURL, dataToReturn}) => {
    const [btnRedirect, setBtnRedirect] = useState(false);
    let history = useHistory();

    const button1 = <Button onClick={(redirectURL == "/tasks/edit/std/" + dataToReturn?.taskID) ? () => setBtnRedirect(!btnRedirect) : () => history.push(redirectURL) }>
      Yes
      { btnRedirect ?
        <Redirect
            to={{
              pathname: "/tasks/edit/std/" + dataToReturn?.taskID,
              state: {
                      buttons: dataToReturn?.buttons,
                      workItemID: dataToReturn?.taskID}
            }}
        />
        :
        <></>
      }
      </Button> 
    const button2 = <Button className="btn-outlined" onClick={() => onHide()} >No </Button>
    const mainText = 
    <div style={{fontSize: '20px'}}>
        Are you sure you want to cancel? <br></br> Your changes will not be saved.
    </div>;

    return (
        <ActionPanel
            show={show}
            onHide={onHide}
            header={"Cancel Confirmation"}
            icon={warningIcon}
            mainText={mainText}
            acceptButton={button1}
            rejectButton={button2}
        />
    )
}

export default CancelModal;